import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-pager.global.pcss?inline';
import encapsulatedStyles from './styles/outline-pager.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-pager';

/**
 * The Outline Core Pager component
 *
 * A reusable LitElement component for displaying pagers.
 *
 * @element outline-pager
 * @extends LitElement
 */
@customElement(componentName)
export class OutlinePager extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  render(): TemplateResult {
    return html`
      <section class="outline-pager">
        <slot></slot>
      </section>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlinePager;
  }
}
